package gr.tech.meetinggenie.util

object CONSTANTS {
    const val FONT_FAMILY  = "Poppins"
    const val FONT_FAMILY2 = "Montserrat"

    const val ROWS_PER_FETCH_REQ = 20

    object DESIGN {
        const val MODAL_OVERLAY_INDEX = 100
    }
}



object BACKEND {
    const val IS_DEV: Boolean = false
    val BACKEND_URL = if (IS_DEV) "http://localhost:8081" else "/api"

    object ROUTES {
        const val USER_OAUTH_LOGIN = "/login-auth"
        const val USER_SIGN_OUT    = "/logout"

        const val MEETINGS        = "/meetings"
        const val MEETINGS_CREATE = "/meetings/create"

        fun meetingById(id: Int)       = "$MEETINGS/$id"
        fun archiveMeeting(id: Int)    = "$MEETINGS/$id/archive"
        fun deleteMeeting(id: Int)     = "$MEETINGS/$id"
        fun meetingResponses(id: Int)  = "$MEETINGS/$id/responses"
        fun myResponse(id: Int)        = "$MEETINGS/$id/my-response"
        fun saveResponse(id: Int)      = "$MEETINGS/$id/response"
        fun submitResponse(id: Int)    = "$MEETINGS/$id/submit"
    }
}

object RES {
    const val CACHE_BUST = "v2026.1"

    object GENERAL {
        const val grlogo       = "grlogo.png"
        const val grlogocenter = "grlogocenter.png"
        const val CURR_YEAR    = "2026"
    }
}
